import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "auto",
  },
  Endbtn: {
    padding: "0 8px !important",
  },
  filters: {},
  utilities: {
    textAlign: "center",
    paddingBlock: 20,
  },
  datePickerStyle: {
    "& .MuiTextField-root": { width: "100%" },
    "& .MuiFormLabel-root": { top: "-5px" },
    "& .MuiInputBase-input": { height: "0.4375em !important" },
  },
  pages: {
    background: "#fff",
    borderRadius: 8,
  },
  lightText: {
    "& .MuiTypography-root": { color: "rgba(0, 0, 0, 0.7)" },
  },
  dataGridTable: {
    paddingBlock: 20,
    "& .MuiDataGrid-columnHeaders": {
      position: "sticky",
      backgroundColor: theme.palette.background.paper,
      zIndex: theme.zIndex.mobileStepper - 1,
      background: "#1D426D33",
    },
    "& .MuiDataGrid-virtualScroller": {
      marginTop: "0 !important",
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": { height: 6 },
    },
    "& .MuiDataGrid-main": { overflow: "visible" },
    "& .MuiDataGrid-root .MuiDataGrid-cell:focus-within": { outline: "none !important" },
    "& .MuiDataGrid-columnHeaderTitle": { fontWeight: 700, textTransform: "uppercase", fontSize: 14 },
    "& .MuiDataGrid-iconSeparator": { display: "none" },
    "& .MuiDataGrid-footerContainer": { justifyContent: "flex-start" },
    "& .MuiTablePagination-selectLabel": { fontSize: 13 },
    "& .MuiTablePagination-displayedRows": { fontSize: 13 },
    "& .MuiTablePagination-select": { fontSize: 13 },
    "& .MuiDataGrid-cell": { whiteSpace: "normal !important", wordWrap: "break-word" },
  },
  tripgridtable: {
    "& .MuiDataGrid-row": { maxHeight: "none !important" },
    "& .MuiDataGrid-cell": { maxHeight: "none !important" },
  },
}));

export default useStyles;
